module.exports = __webpack_public_path__ + "static/media/verdeBaby.2f9a15e9.jpg";